



































































































































































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, onMounted, ref } from "@vue/composition-api";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import Processing from "@/components/table/Processing.vue";
import { UseDropdownItems } from "@/common/composition/dropdown-items";
import { UseLoading } from "@/common/composition/loading";
import Spinner from "@/components/Spinner.vue";
import { state } from "../data/state";
import { SharedState } from "@/common/state";
import { ICONS } from "@/common/icons.map";
import { path } from "@/fp";
import { CustomLabelAnalysis } from "../data/model";
import * as api from "../data/api";
import LabelAnalysisStage from "./LabelAnalysisStage.vue";
export default Vue.extend({
  components: {
    Modal,
    Processing,
    DropDownSimple,
    Spinner,
    LabelAnalysisStage,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "60rem",
      height: "70rem",
    };

    const current_stage = ref(1);
    const [is_loading, set_is_loading] = UseLoading(false).as_arr();

    // step 1 vars
    const [
      l0_labels,
      selected_l0,
      set_selected_l0,
      init_l0_labels,
    ] = UseDropdownItems<{
      id: string;
      name: string;
      icon: string;
    }>([]);

    const name = ref("");
    const desc = ref("");
    const selected_sensitivity_type = ref("Internal");
    const files = ref<File[]>([]);

    const current_label_names = computed(() =>
      Object.values(SharedState.allInfoTypes.value).reduce(
        // @ts-ignore
        (acc, { labelName, deleted }) => {
          if (labelName && !deleted) {
            acc[labelName.toLowerCase()] = true;
          }
          return acc;
        },
        {} as { [key: string]: boolean }
      )
    );
    const does_name_exist = computed(
      () => current_label_names.value[name.value.toLowerCase()]
    );

    const [is_analyzing_data, set_is_analyzing_data] = UseLoading(
      false
    ).as_arr();
    const label_analysis = ref<CustomLabelAnalysis>({
      associatedLabels: {
        existingLabel: "",
        labelExists: false,
        overlappingLabels: [],
      },
      associatedConcepts: [],
      examplesRawBlobKeys: [],
      notEnoughSamples: false,
      language: "en",
      contentOutOfScope: [],
    });

    const folder_path = ref("");
    const folder_paths = ref<string[]>([]);

    const [
      sensitivities,
      selected_sensitivity,
      set_selected_sensitivity,
    ] = UseDropdownItems(
      [
        "None sensitivity",
        "Low sensitivity",
        "Medium sensitivity",
        "High sensitivity",
      ].map((name, index) => {
        return {
          id: index.toString(),
          val: index,
          name,
        };
      })
    );

    const next = () => {
      switch (current_stage.value) {
        case 1:
          current_stage.value = 2;
          analyze_topic_input();
          break;
        case 2:
          create_label();
          break;
      }
    };

    const prev = () => {
      switch (current_stage.value) {
        case 2:
          current_stage.value = 1;
          break;
        case 3:
          current_stage.value = 2;
          break;
      }
    };

    const ok_btn_text = computed(() => {
      switch (current_stage.value) {
        case 1:
          return "Analyze";
        case 2:
          return "Approve & Create";
      }
    });

    const is_stage_valid = computed(() => {
      switch (current_stage.value) {
        case 1:
          return (
            name.value.length > 0 &&
            !does_name_exist.value &&
            desc.value.length > 0 &&
            files.value.length >= 5
          );
        case 2:
          const { labelExists } = label_analysis.value.associatedLabels;
          return (
            !labelExists && label_analysis.value.associatedConcepts.length > 0
          );
      }
    });

    const set_files = (e: Event) => {
      const target = e.target as HTMLInputElement;
      if (target.files) {
        files.value = [...files.value, ...Array.from(target.files)];
      }
    };

    const remove_file = (index: number) => {
      files.value = files.value.filter((_, i) => i !== index);
    };

    const analyze_topic_input = async () => {
      set_is_analyzing_data(true);
      const res = await api.send_new_label_for_analysis({
        desc: desc.value,
        name: name.value,
        files: files.value,
      });
      if (res.success) {
        label_analysis.value = res.value;
      }
      set_is_analyzing_data(false);
    };

    const add_folder_path = () => {
      folder_paths.value = [...folder_paths.value, folder_path.value];
      folder_path.value = "";
    };

    const remove_folder_path = (index: number) => {
      folder_paths.value = folder_paths.value.filter((_, i) => i !== index);
    };

    const create_label = async () => {
      set_is_loading(true);
      const res = await state.create_label({
        name: name.value,
        desc: desc.value,
        sensitivity: selected_sensitivity.value?.val!,
        sensitivityType: "Internal", //selected_sensitivity_type.value!,
        parentId: selected_l0.value?.id!,
      });
      console.log("create_label res: ", res);
      if (res.success) {
        const label_id = res.value;
        await api.send_created_label_for_analysis({
          l0LabelId: selected_l0.value?.id!,
          labelId: label_id,
          labelName: name.value,
          desc: desc.value,
          associatedLabels: label_analysis.value.associatedLabels.overlappingLabels.map(
            (d) => d.labelName
          ),
          associatedConcepts: label_analysis.value.associatedConcepts,
          examplesRawBlobKeys: label_analysis.value.examplesRawBlobKeys,
        });
        emit("submit", { label_id, label_name: name.value });
      }
      set_is_loading(false);
    };

    onMounted(() => {
      init_l0_labels(
        SharedState.l0InfoTypes.value
          .filter((f) => f.code !== 7)
          .map((l0) => {
            return {
              id: l0.id,
              icon: ICONS.L0_ICONS.get(l0.code),
              name: l0.labelName,
            };
          })
      );
      set_selected_l0(path("modalData.l0", () => "")(props));
    });

    return {
      config,
      is_loading,
      current_stage,
      next,
      prev,
      is_stage_valid,
      ok_btn_text,
      // step 1
      l0_labels,
      selected_l0,
      set_selected_l0,
      name,
      does_name_exist,
      desc,
      selected_sensitivity_type,
      sensitivities,
      selected_sensitivity,
      set_selected_sensitivity,
      files,
      set_files,
      remove_file,
      // step 2
      is_analyzing_data,
      label_analysis,
      // step 3
      folder_path,
      folder_paths,
      add_folder_path,
      remove_folder_path,
    };
  },
});
